import { Grid } from "@mui/material";
import { FastField, Field } from "formik";
import {
  MyMultiSelect,
  MySelect,
  MyTextField
} from "../../Lib/componentLibrarys";
import { useState } from "react";

export const FormNhapUpdate = ({
  values,
  errors,
  setFieldValue,
  chucVuList,
  phongBanList,
  coQuanQuanLyList,
  rolesByCapList,
  doanhNghiepList,
  coSoSanXuatList,
  coSoCheBienList,
  coSoPhanPhoiList
}) => {
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <FastField name="userName">
            {({ field }) => (
              <MyTextField
                disabled
                required
                label="Tài khoản:"
                placeholder="Nhập..."
                errors={errors?.userName}
                helperText={errors?.userName}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="fullName">
            {({ field }) => (
              <MyTextField
                required
                label="Họ tên:"
                placeholder="Nhập..."
                errors={errors?.fullName}
                helperText={errors?.fullName}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Doanh nghiệp:"
            placeholder="Chọn..."
            value={values?.doanhNghiep}
            options={doanhNghiepList || []}
            name="tenDoanhNghiep"
            onChange={(event, value) => {
              setFieldValue(`doanhNghiep`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <FastField name="email">
            {({ field }) => (
              <MyTextField
                required
                label="Email:"
                placeholder="Nhập..."
                errors={errors?.email}
                helperText={errors?.email}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="mobile">
            {({ field }) => (
              <MyTextField
                label="Điện thoại:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="address">
            {({ field }) => (
              <MyTextField label="Địa chỉ:" placeholder="Nhập..." {...field} />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Cơ quan quản lý:"
            placeholder="Chọn..."
            value={values?.coQuanQuanLy}
            options={coQuanQuanLyList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`coQuanQuanLy`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Phòng ban:"
            placeholder="Chọn..."
            value={values?.phongBan}
            options={phongBanList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`phongBan`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Chức vụ:"
            placeholder="Chọn..."
            value={values?.chucVu}
            options={chucVuList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`chucVu`, value);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <div style={{ fontWeight: 700 }}>--- Thông tin cơ sở ---</div>
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Cơ sở sản xuất:"
            placeholder="Chọn..."
            value={values?.coSoSanXuat}
            options={coSoSanXuatList || []}
            name="tenCoSoSanXuat"
            onChange={(event, value) => {
              setFieldValue(`coSoSanXuat`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Cơ sở chế biến:"
            placeholder="Chọn..."
            value={values?.coSoCheBien}
            options={coSoCheBienList || []}
            name="tenCoSoCheBien"
            onChange={(event, value) => {
              setFieldValue(`coSoCheBien`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Cơ sở phân phối:"
            placeholder="Chọn..."
            value={values?.coSoPhanPhoi}
            options={coSoPhanPhoiList || []}
            name="tenCoSoPhanPhoi"
            onChange={(event, value) => {
              setFieldValue(`coSoPhanPhoi`, value);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <div style={{ fontWeight: 700 }}>--- Nhóm người dùng ---</div>
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            required
            label="Thuộc nhóm người dùng:"
            placeholder="Chọn..."
            onChange={(option, value) => {
              setFieldValue(`roles`, value);
            }}
            value={values?.roles || []}
            options={rolesByCapList || []}
            name="name"
            errors={errors?.roles}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export const FormNhapAdd = ({
  values,
  errors,
  setFieldValue,
  chucVuList,
  phongBanList,
  coQuanQuanLyList,
  rolesByCapList,
  doanhNghiepList,
  coSoSanXuatList,
  coSoCheBienList,
  coSoPhanPhoiList
}) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <FastField name="userName">
            {({ field }) => (
              <MyTextField
                required
                label="Tài khoản:"
                placeholder="Nhập..."
                errors={errors?.userName}
                helperText={errors?.userName}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="fullName">
            {({ field }) => (
              <MyTextField
                required
                label="Họ tên:"
                placeholder="Nhập..."
                errors={errors?.fullName}
                helperText={errors?.fullName}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <Field name="password">
            {({ field }) => (
              <MyTextField
                required
                label="Mật khẩu:"
                type={showPassword ? "text" : "password"}
                placeholder="Nhập..."
                showpassword={() => setShowPassword(!showPassword)}
                openeye={showPassword}
                errors={errors?.password}
                helperText={errors?.password}
                {...field}
              />
            )}
          </Field>
        </Grid>
        {/* <Grid item xs={6}>
          <MySelect
            label="Doanh nghiệp:"
            placeholder="Chọn..."
            value={values?.doanhNghiep}
            options={doanhNghiepList || []}
            name="tenDoanhNghiep"
            onChange={(event, value) => {
              setFieldValue(`doanhNghiep`, value);
            }}
          />
        </Grid> */}
        <Grid item xs={6}>
          <FastField name="email">
            {({ field }) => (
              <MyTextField
                required
                label="Email:"
                placeholder="Nhập..."
                errors={errors?.email}
                helperText={errors?.email}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="mobile">
            {({ field }) => (
              <MyTextField
                label="Điện thoại:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="address">
            {({ field }) => (
              <MyTextField label="Địa chỉ:" placeholder="Nhập..." {...field} />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Cơ quan quản lý:"
            placeholder="Chọn..."
            value={values?.coQuanQuanLy}
            options={coQuanQuanLyList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`coQuanQuanLy`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Phòng ban:"
            placeholder="Chọn..."
            value={values?.phongBan}
            options={phongBanList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`phongBan`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Chức vụ:"
            placeholder="Chọn..."
            value={values?.chucVu}
            options={chucVuList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`chucVu`, value);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <div style={{ fontWeight: 700 }}>--- Thông tin cơ sở ---</div>
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Cơ sở sản xuất:"
            placeholder="Chọn..."
            value={values?.coSoSanXuat}
            options={coSoSanXuatList || []}
            name="tenCoSoSanXuat"
            onChange={(event, value) => {
              setFieldValue(`coSoSanXuat`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Cơ sở chế biến:"
            placeholder="Chọn..."
            value={values?.coSoCheBien}
            options={coSoCheBienList || []}
            name="tenCoSoCheBien"
            onChange={(event, value) => {
              setFieldValue(`coSoCheBien`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Cơ sở phân phối:"
            placeholder="Chọn..."
            value={values?.coSoPhanPhoi}
            options={coSoPhanPhoiList || []}
            name="tenCoSoPhanPhoi"
            onChange={(event, value) => {
              setFieldValue(`coSoPhanPhoi`, value);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <div style={{ fontWeight: 700 }}>--- Nhóm người dùng ---</div>
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            required
            label="Thuộc nhóm người dùng:"
            placeholder="Chọn..."
            onChange={(option, value) => {
              setFieldValue(`roles`, value);
            }}
            value={values?.roles || []}
            options={rolesByCapList || []}
            name="name"
            errors={errors?.roles}
          />
        </Grid>
      </Grid>
    </div>
  );
};
